export const ButtonStyleValues: any = {
    round: 0,
    reportSquare: 1
  };
